import { Text } from '@chakra-ui/react';
import RoutableModal from 'components/general/RoutableModal';
import { FormProvider } from 'react-hook-form';
import DocumentRenewalForm from './DocumentRenewalForm';
import { useDocumentRenewalForm } from './lib';

function DocumentRenewal() {
  const { loading, form, onSubmit, documentTemplates, initialLoadDone } = useDocumentRenewalForm();

  const templates = documentTemplates.data
    ? documentTemplates.data.documentTemplates.edges.map(edge => edge.node!)
    : [];

  return (
    <RoutableModal
      title="Document Renewal"
      loading={loading}
      buttons={{ action: { text: 'Save', handler: onSubmit } }}
    >
      <Text mb={10}>
        You can upload a new file to replace the existing one or send an electronic signature
        request to the client.
      </Text>
      <FormProvider {...form}>
        {initialLoadDone && <DocumentRenewalForm templates={templates} />}
      </FormProvider>
    </RoutableModal>
  );
}

export default DocumentRenewal;
